export * from '@lexical/react/LexicalBlockWithAlignableContents'
